
const state = {
  positionTop: 0,
  savePage: ['writingDetail', 'newsroomReportDetail', 'newsroomFactDetail', 'NoticeDetail']
}

const mutations = {
  UPDATE_POSITION_TOP (pState, payload) {
    pState.positionTop = payload
  }
}

const getters = {
  GET_POSITION_TOP: state => state.positionTop,
  GET_SAVE_PATE: state => state.savePage
}

const actions = {
  positionTopChange ({ commit }, data) {
    commit('UPDATE_POSITION_TOP', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
